export default __webpack_public_path__ + "static/media/barrel.ef6c24c5.png";